import { type Control, Controller, type FieldValues, type Path, type PathValue, type Validate } from 'react-hook-form';
import Input, { type InputProps } from '../Input';

interface Props<T extends FieldValues> extends InputProps {
  name: Path<T>;
  control: Control<T>;
  validate?: Validate<PathValue<T, Path<T>>, T> | Record<string, (value: any) => boolean | string>;
}

export default function <T extends FieldValues>({ name, control, validate, ...props }: Props<T>) {
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: props.isRequired ? 'Required' : false,
        ...(validate && { validate }),
      }}
      render={({ field, fieldState: { error } }) => <Input {...props} {...field} error={error?.message} />}
    />
  );
}
